import React from 'react'

const StrokeSignup = props => (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40.000000pt" height="40.000000pt" viewBox="0 0 40.000000 40.000000"
 preserveAspectRatio="xMidYMid meet" {...props}>
<g transform="translate(0.000000,44.000000) scale(0.053333,-0.053333)"
fill="#FFFFFF" stroke="none">
<path d="M260 699 c-94 -39 -120 -158 -50 -228 36 -35 36 -37 8 -45 -37 -9
-95 -63 -117 -109 -25 -51 -28 -135 -6 -176 23 -45 76 -64 190 -68 62 -3 119
1 150 9 48 12 50 15 53 50 l3 37 -58 3 -58 3 0 60 0 60 58 3 57 3 0 34 c0 29
-7 40 -42 65 -22 16 -47 30 -55 30 -18 0 -16 10 5 29 73 65 67 174 -12 226
-32 21 -93 28 -126 14z"/>
<path d="M510 330 l0 -60 -60 0 -60 0 0 -40 0 -40 60 0 60 0 0 -60 0 -60 45 0
45 0 0 60 0 60 60 0 60 0 0 40 0 40 -60 0 -60 0 0 60 0 60 -45 0 -45 0 0 -60z"/>
</g>
</svg>
)

export default StrokeSignup;
